import { Pipe, PipeTransform } from '@angular/core';
import { RelationshipStatus } from '../models/enum/shared/relationship-status';
import { RelationshipStatusUtils } from '../utils/relationship-status-utils';

@Pipe({
  name: 'relationshipStatusIsPartneredForDisplay',
  standalone: true
})
export class RelationshipStatusIsPartneredForDisplayPipe implements PipeTransform {
  transform(status: RelationshipStatus): boolean {
    return RelationshipStatusUtils.isPartneredStatusForDisplay(status);
  }
}
